module.exports = __webpack_public_path__ + "images/guide-shard-green.svg";